import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress"; // progress bar
import Layouts from "../layouts/index.vue";
import { getToken } from "@/utils/auth";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Layouts,
    redirect: "/UserManage",
    children: [
      // {
      //   path: "/Home",
      //   name: "Home",
      //   component: () => import(/* webpackChunkName: "Home" */ "@/views/MapHome.vue"),
      //   meta: {
      //     title: "首页",
      //   },
      // },
      {
        path: "/Organization",
        name: "Organization",
        component: (resolve) => require(["@/views/configuration/organization/index.vue"], resolve),
        meta: { title: "组织机构" },
      },
      // 用户管理
      {
        path: "/UserManage",
        name: "UserManage",
        component: (resolve) => require(["@/views/configuration/user/index.vue"], resolve),
        meta: { title: "用户管理" },
      },
      // 角色权限
      {
        path: "/RoleManage",
        name: "RoleManage",
        component: (resolve) => require(["@/views/configuration/role/index.vue"], resolve),
        meta: { title: "角色权限" },
      },
      {
        path: "/Dictionaries",
        name: "Dictionaries",
        component: (resolve) => require(["@/views/configuration/Dictionaries/index.vue"], resolve),
        meta: { title: "字典管理" },
      },
      // {
      //   path: "/UserManage",
      //   name: "UserManage",
      //   component: () => import(/* webpackChunkName: "UserManage" */ "@/views/SysManage/UserManage/index.vue"),
      //   meta: {
      //     title: "用户管理",
      //   },
      // },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "Login" */ "@/views/Login.vue"),
    meta: {
      title: "登录",
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : "石板滩全域土地动态管理系统";
  NProgress.start();
  const token = getToken();
  if (token) {
    const userInfo = store.state.user.userInfo;
    if (userInfo == null || !userInfo.personId) {
      let data = await store.dispatch("user/getUserInfo");
      store.commit("permission/setRoutes", {
        path: data.route,
        name: data.name,
        meta: {
          title: data.dispalyName,
          affix: true,
        },
      });
    }
    next();
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
export default router;
